<template>
    <nav class="queries_panel_menu_options">
        <div
            v-if="
                total_selected_filters > 0 ||
                App.root_activated_view ===
                    'application_solutions' ||
                App.root_activated_view ===
                    'single_application_solution'
            "
            @click="newQuery"
            class="button black30 uppercase"
        >
            <i class="icon-query"></i
            >{{ translations.query_nav_options.new_query }}
        </div>
        <div
            @click="goToFilters"
            v-if="
                App.root_activated_view ===
                    'application_solutions' ||
                App.root_activated_view ===
                    'single_application_solution'
            "
            class="button black30 uppercase"
        >
            <i class="icon-refine-query"></i
            >{{ translations.generic.refine_queries }}
        </div>
        <div
            @click="openSaveQueryModal"
            v-show="false"
            v-if="
                App.root_activated_view ===
                    'application_solutions' ||
                App.root_activated_view ===
                    'single_application_solution'
            "
            class="button black30 uppercase"
        >
            <i class="icon-save-query"></i
            >{{ translations.query_nav_options.save_query }}
        </div>
        <div
            @click="openSavedQueriesModal"
            v-show="false"
            v-bind:class="[{ 'saved-group': total_selected_filters > 0 }]"
            class="button black30 uppercase open_saved_queries_modal"
        >
            <i class="icon-saved-queries"></i
            >{{ translations.query_nav_options.saved_queries }}
        </div>
    </nav>
</template>

<script>
import App from './../application.js'

export default {
    data: function () {
        return {
            App: App,
            total_selected_filters: 0,
            translations: {
                query_nav_options: App.current_translations['query_nav_options'],
                generic: App.current_translations['generic']
            }
        }
    },
    mounted: function () {
        var self = this;
        App.bus.$on('on_selected_item', function (total_selected_filters) {
            self.total_selected_filters = total_selected_filters;
        });

        App.bus.$on('is_clean_query', function () {
            self.current_query = {};
        });
    },
    methods: {
        openSavedQueriesModal: function () {
            App.bus.$emit('modal_saved_queries');
        },
        newQuery: function () {
            App.query.clean();
            this.$router.push('/query')
        },
        goToFilters: function () {
            // App.root_activated_view = 'query_filters';
            this.$router.push('/query')
            App.bus.$emit('is_back_to_filter_view');
        },
        openSaveQueryModal: function () {
            App.bus.$emit('modal_save_query', this.current_query);
        }
    },
}
</script>

<style>
</style>